import { lazy, Suspense } from "react";

import { useDomSize } from "~/hook/base/useDomSize.ts";
import { getDenormalizedPoints } from "~/service/util.ts";
import { type Line } from "~/ui/base/Canvas.tsx";
import { createWebDraggableSheet } from "~/ui/base/WebDraggableSheet.tsx";

const CanvasRenderer = lazy(() =>
  import("~/ui/base/CanvasRenderer.tsx").then((module) => ({
    default: module.CanvasRenderer,
  })),
);

export const WebShowDrawingSheet = createWebDraggableSheet<{
  lines: Line[];
  title: string;
}>(({ context, titleId }) => {
  const {
    domRef,
    size: { height, width },
  } = useDomSize<HTMLDivElement>();

  return (
    <div data-testid="그림 보기">
      <h1
        className="text-lg font-semibold text-zinc-800 dark:text-zinc-100"
        id={titleId}
      >
        {context.title}
      </h1>
      <div className="h-6" />
      <div className="aspect-square w-full" ref={domRef}>
        <Suspense fallback={<div className="size-full rounded-2xl bg-black" />}>
          <CanvasRenderer
            height={height}
            lines={getDenormalizedPoints(width)(context.lines)}
            width={width}
          />
        </Suspense>
      </div>
    </div>
  );
});
